import React, {Fragment} from "react";
import {Card, CardBody, CardDeck, CardHeader} from "reactstrap";
import {withRouter} from "react-router-dom";
import {AGENT_CONFIG} from "./AgentsTableConfig";
import ManagedAgentService from "../../services/managedagentonboarding/ManagedAgentService";
import ToastHelper from "../../utils/ToastHelper";
import SFXLoadingComponent from "../../components/SFXLoadingComponent";
import LinkComponent from "../../components/LinkComponent";

class ManagedAgentView extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            firstName: "",
            lastName: "",
            agentCode: "",
            agentStatus: "",
            dateCreated: "",
            loading: true

        }

    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        ManagedAgentService.retrieveById(this.props.agentId)
            .then(response => {
                if (response.id) {
                    this.setState({
                            firstName: response.person.firstName,
                            lastName: response.person.lastName,
                            phoneNumber: response.contacts[0].contactValue,
                            agentCode: response.agentCode,
                            agentStatus: response.status,
                            dateCreated: response.dateCreated,
                            loading: false
                        },
                    )

                } else {
                    ToastHelper.formatError(response);
                }
            });
    }

    render() {
        if (this.state.loading) {
            return <SFXLoadingComponent/>
        }
        return <Fragment>

            {this.renderManagedAgentView()}

        </Fragment>
    }

    renderManagedAgentView() {
        let agentData = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phoneNumber: this.state.phoneNumber,
            agentCode: this.state.agentCode,
            agentStatus: this.state.agentStatus,
            dateCreated: this.state.dateCreated
        }
        return <Fragment>
            <CardDeck>
                <Card className="p-2 agentContainer">
                    <CardHeader>
                        <LinkComponent href="#" onClick={this.props.btnBackClick}><span
                            className={"agentCardTableHeader"}>My Agents</span></LinkComponent>
                        {' / ' + this.state.firstName + " " + this.state.lastName}
                    </CardHeader>
                    <CardBody>
                        {AGENT_CONFIG.map((value, index) => {
                            return <Fragment key={index}>
                                <h6>{value.label}</h6>
                                <h6 style={{color: "grey"}}>{agentData[value.dataField]}</h6>
                            </Fragment>
                        })}
                    </CardBody>

                </Card>
            </CardDeck>
        </Fragment>
    }
}

export default withRouter(ManagedAgentView);